import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo/Logo.js';
import SalesPhone from '../SalesPhone/SalesPhone.jsx';
import BurgerButton from '../BurgerButton/BurgerButton.js';
import { FaEnvelope, FaPhone, FaUser } from 'react-icons/fa';
import {
  EMAIL,
  EMAIL_HREF,
  PHONE_DISPLAY,
  PHONE_HREF,
  STRELETS_EMAIL,
  STRELETS_EMAIL_HREF,
} from '../../constants/contactInfo.js';
import { navigationItems } from '../../constants/navigationItems.js';
import './Header.css';
import HeaderNavigationItem from './HeaderNavigationItem.jsx';

function Header() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className="header">
      <div className="header__container-top">
        <div className="header__contacts">
          <a href={PHONE_HREF} className="header__phone" target="_blanck">
            <FaPhone /> {PHONE_DISPLAY}
          </a>
          <SalesPhone className="header__phone" />
          {!isSmallScreen ? (
            <a
              href={EMAIL_HREF}
              className="header__email"
              target="_blanck"
            >
              <FaEnvelope /> {EMAIL}
            </a>
          ) : null}
          {!isSmallScreen ? (
            <a
              href={STRELETS_EMAIL_HREF}
              className="header__email"
              target="_blanck"
            >
              <FaEnvelope /> {STRELETS_EMAIL}
            </a>
          ) : null}
        </div>

        <div className="header__logo-wrap">
          <Logo />
        </div>

        {isSmallScreen ? (
          <BurgerButton />
        ) : (
          <div className="header__actions">
            <a
              href="https://vk.ru/id607995315"
              className="header__social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="ВКонтакте"
            >
              <img
                src="/images/socials/VK.svg.webp"
                alt=""
                className="header__social-icon"
              />
            </a>
            <a
              href="https://max.ru/join/yLUnVZOKZLgNUSNxL91fDeSqhEm7MK9yCIMvaGrlODE"
              className="header__social-link"
              target="_blank"
              rel="noreferrer"
              aria-label="MAX"
            >
              <img
                src="/images/socials/MAX.svg.webp"
                alt=""
                className="header__social-icon"
              />
            </a>
            <Link to="/personal-account/" className="header__account-link">
              <FaUser />
              Личный кабинет
            </Link>
          </div>
        )}
      </div>
      <div className="header__container-center">
        <h1 className="header__title">
          Самарское областное отделение Общероссийской общественной организации
        </h1>
        <h2 className="header__subtitle">
          «Всероссийское добровольное пожарное общество»
        </h2>
      </div>
      <div className="header__container-bottom">
        <div className="header__container-bottom-inner">
          <nav className="header__navigation">
            <ul className="header__navigation-list">
              {navigationItems.map((item) => (
                <HeaderNavigationItem key={item.path} {...item} />
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
